
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as LeaveClassIconComponent } from "./leave-class-icon.svg";

export const LeaveClassIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <LeaveClassIconComponent {...props} />;
};
